export const TILE_SPRITES: Record<number, string> = {
  1: 'env_grass_plain',
  2: 'env_dirt_plain',
  3: 'env_river_vertical',
  4: 'env_tree_round',
  5: 'env_flowers_patch_pink',
  6: 'env_rock_large',
  7: 'env_fence_long',
  8: 'env_wood_bridge',
  9: 'obj_cottage',
  10: 'env_well_small',
  11: 'env_dirt_pebbles',
  12: 'env_bush_round',
  13: 'env_stump_plain',
  14: 'env_altar_ruined',
  15: 'env_signpost',
  16: 'env_barrel',
  17: 'env_campfire',
  18: 'env_bench',
  19: 'env_lamp_post',
  20: 'env_grass_clump_01',
  21: 'env_flowers_patch_white',
  22: 'env_sapling',
  23: 'env_wheat',
  24: 'env_cabbage',
  25: 'env_farmland_plain',
  26: 'obj_festival_plaza',
  27: 'obj_T_house',
  28: 'obj_boluo_farmhouse',
  29: 'obj_mayor_house',
  30: 'obj_shop',
  31: 'obj_central_tower',
}

export const TILESET_TILE_SPRITES: Record<string, Partial<Record<number, string>>> = {
  holy: {
    1: 'holy_floor_tile_01',
    2: 'holy_floor_tile_02',
    3: 'holy_spring_edge_01',
    4: 'holy_column_plain',
    5: 'holy_crystal_blue',
    6: 'holy_crystal_purple',
    7: 'holy_barrier_gold',
    8: 'holy_stairs_small',
    9: 'holy_gate_golden',
    10: 'holy_fountain',
    11: 'holy_path_blue',
    12: 'holy_cloud_small',
    13: 'holy_pedestal_orb',
    14: 'holy_altar_main',
    15: 'holy_stele_qinglong',
    16: 'holy_pedestal_book',
    17: 'holy_brazier_fire',
    18: 'holy_pedestal_crown',
    19: 'holy_brazier_arcane',
    20: 'holy_sparkles',
    21: 'holy_holy_light_small',
    22: 'holy_cloud_large',
    23: 'holy_path_yellow',
    24: 'holy_path_green',
    25: 'holy_path_orange',
    26: 'holy_altar_lectern',
  },
  dark: {
    1: 'dark_floor_purple_cracks',
    2: 'dark_cave_floor',
    3: 'dark_swamp_water_01',
    4: 'dark_cliff_pillar',
    5: 'dark_crystal_cluster',
    6: 'dark_rocks_crystal',
    7: 'dark_chain_hook',
    8: 'dark_swamp_bridge',
    9: 'dark_demon_gate_small',
    10: 'dark_drain_grate',
    11: 'dark_floor_brick',
    12: 'dark_thorn_bush',
    13: 'dark_dead_tree_01',
    14: 'dark_ritual_altar',
    15: 'dark_tombstone',
    16: 'dark_hanging_cage',
    17: 'dark_purple_torch',
    18: 'dark_bones_01',
    19: 'dark_hanging_lantern',
    20: 'dark_soil_mushroom',
    21: 'dark_bones_02',
    22: 'dark_dead_tree_02',
    23: 'dark_floor_skull_panel',
    24: 'dark_magic_circle_green',
    25: 'dark_earth_floor',
    26: 'dark_magic_circle_purple',
  },
} as const

export function resolveTileSpriteKey(tileSprites: Record<number, string>, tileset: string, tileId: number): string | undefined {
  return TILESET_TILE_SPRITES[tileset]?.[tileId] ?? tileSprites[tileId]
}
